import React from 'react';
import { usePageMeta } from '../../hooks/usePageMeta';
import { PageHero } from '../../components/ui/PageHero';
import { Section } from '../../components/ui/Section';
import { ActionLink } from '../../components/ui/ActionLink';
import { TextLink } from '../../components/ui/TextLink';
import { BenefitList } from '../../components/ui/BenefitList';
import { StepList } from '../../components/ui/StepList';
import { EnquirySection } from '../../components/forms/EnquirySection';
import { applySteps, careerBenefits, openRoles } from '../../data/pageContent';
import { contact } from '../../data/contact';
import { images } from '../../data/images';
export function Careers() {
  usePageMeta('English Teaching Jobs and Careers | ES World', 'Find English teaching jobs and school roles at ES World. Grow with training and an international team. See open roles.');
  return <>
      <PageHero breadcrumbs={[{
      label: 'About Us',
      to: '/about/who-we-are'
    }, {
      label: 'Careers',
      to: '/about/careers'
    }]} title="English teaching jobs and careers at ES World" lead="Look at English teaching jobs and school roles at ES World. We look for teachers and staff who enjoy helping people learn. You receive training every term and work with colleagues from many countries." primary={{
      label: 'View open roles',
      to: '#roles'
    }} secondary={{
      label: 'Read how we teach',
      to: '/about/teaching-methodology'
    }} image={images.teacher} imageAlt="A teacher working with two students" data-id="element-938" data-mp="yxog8o92wpo5" />

      <Section id="why" title="Grow your teaching career" subhead="We train our teachers every term and support them to take the next step." aside={<TextLink to="/programmes/teacher-training-course" data-id="element-940" data-mp="3pajbgqcnrmmf">Explore our teacher training</TextLink>} data-id="element-939" data-mp="3u7jesti4ib9u">
        <BenefitList items={careerBenefits} columns={3} data-id="element-941" data-mp="70h4rugrquad" />
        <div className="mt-10" data-id="element-942" data-mp="32jespf6c45x">
          <ActionLink to={`${contact.emailLink}?subject=Job%20application`} data-id="element-943" data-mp="2z5ctiaf9wz0">Email your CV</ActionLink>
        </div>
      </Section>

      <Section id="roles" bg="cream" title="Roles open right now" description="These are sample roles. Approved job listings appear here before launch." mockup="Sample job listings" data-id="element-944" data-mp="f39kt4ox89iw">
        <ul className="divide-y divide-line border-y border-line" data-id="element-945" data-mp="oudym12v1oc5">
          {openRoles.map(role => <li key={role.title} className="grid gap-2 py-5 md:grid-cols-12 md:items-center" data-id="element-946" data-mp="su4o81gnhyf3">
              <span className="type-card-title text-ink md:col-span-6" data-id="element-947" data-mp="xspo1zrzqg30">{role.title}</span>
              <span className="md:col-span-3" data-id="element-948" data-mp="12u5a9v5wmsmz">{role.type}</span>
              <span className="text-muted md:col-span-3" data-id="element-949" data-mp="17s6w2nupt625">{role.location}</span>
            </li>)}
        </ul>
      </Section>

      <Section id="apply" title="Apply in three steps" description="Our hiring process is short and clear. We reply to every application." data-id="element-950" data-mp="34licgcghmmfc">
        <StepList items={applySteps} data-id="element-951" data-mp="39lo07hjmzos5" />
      </Section>

      <EnquirySection bg="grey" title="Ask about working with us" description="Tell us the role you want and a little about your experience. Our team will reply by email." submitLabel="Send my job enquiry" showCourseFields={false} messageLabel="Your experience and the role you want" data-id="element-952" data-mp="1qph1c7hcv2xj" />
    </>;
}